<template>
  <base-dropdown
    placement="bottom-start"
    :width="dropdownWidth"
    :disabled="disabled"
    popoverClass="field-dropdown"
    class="hide-dropdown"
  >
    <div class="around-list">
      <el-input
        class="searchBar"
        placeholder="搜索字段"
        prefix-icon="el-icon-search"
        v-model="searchText"
        @input="search"
      ></el-input>
      <div class="column-check-list" v-ps>
        <draggable
          group="controlList"
          v-model="filterFields"
          :animation="100"
          :disabled="filterFields.length !== fields.length"
          filter=".forbid"
          handle=".mover"
          style="margin-right: 10px;"
        >
          <div
            class="control-column"
            v-for="field in filterFields"
            :key="field.value"
            @click="clickColumn(field)"
            :class="field.title || field.value.length !== 24 ? 'forbid' : ''"
          >
            <el-switch
              :value="!view.hides.includes(field.value)"
              :disabled="
                field.title ||
                  view.titleCid === field.value ||
                  (view.coverCid ? view.coverCid === field.value : false) ||
                  (view.type === 'GANTT' && view.ganttConfig.milestone
                    ? view.ganttConfig.milestone === field.value
                    : false)
              "
            ></el-switch>
            <svg-icon
              :icon-class="'control_' + field.type"
              style="margin: 0 4px; color:#1989fa"
            ></svg-icon>
            {{ field.label }}
            <svg-icon
              v-if="
                filterFields.length === fields.length && !field.title && field.value.length === 24
              "
              icon-class="svgo_drag"
              class="mover"
            ></svg-icon>
          </div>
        </draggable>
      </div>
      <div v-if="!searchText" class="quick-operate">
        <el-button size="small" class="quick-button" @click="showAll">显示全部</el-button>
        <el-button size="small" class="quick-button" @click="hideAll">隐藏全部</el-button>
      </div>
    </div>
    <template v-slot:reference>
      <div class="selector" :class="disabled ? 'selector-diabled' : ''" ref="reference">
        显示
        <span>{{ showLength }}</span>
        列
      </div>
    </template>
  </base-dropdown>
</template>
<script>
import BaseDropdown from "@/components/UIComponents/Dropdown"
import draggable from "vuedraggable"
export default {
  name: "hide-dropdown",
  components: { BaseDropdown, draggable },
  data() {
    return {
      figuresWidth: 0,
      searchText: "",
      filterFields: []
    }
  },
  props: {
    view: Object,
    fieldsMap: Array,
    canHideFieldsMap: Object,
    disabled: {
      type: Boolean,
      default: false
    },
    from: String
  },
  mounted() {
    this.figuresWidth = this.$refs.reference.clientWidth
    if (this.from !== "dialog") {
      window.onresize = () => {
        this.figuresWidth = this.$refs.reference.clientWidth
      }
    }
  },
  watch: {
    "view.id": {
      handler() {
        this.search()
      },
      immediate: true
    },
    filterFields: {
      handler(newValue, oldValue) {
        if (newValue.length === this.fields.length) {
          this.view.fieldsOrder = this.filterFields.slice(0, -5).map(field => field.value)
        }
      },
      immediate: true,
      deep: true
    }
  },
  computed: {
    fields() {
      return (
        this.view?.fieldsOrderIds
          ?.map(fieldId => this.canHideFieldsMap[fieldId])
          .filter(field => field.type !== "chart") || []
      )
    },
    dropdownWidth() {
      return this.figuresWidth.toString()
    },
    showLength() {
      return this.fields?.filter(field => !this.view.hides.includes(field.cid)).length
    }
  },
  methods: {
    search() {
      this.filterFields = this.fields.filter(field => field.label.includes(this.searchText))
    },
    showAll() {
      this.view.hides = []
    },
    hideAll() {
      this.view.hides = this.fields
        .filter(
          field =>
            !field.title &&
            this.view.titleCid !== field.value &&
            (this.view.type === "GANTT" && this.view.ganttConfig.milestone
              ? this.view.ganttConfig.milestone !== field.value
              : true)
        )
        .map(field => {
          return field.value
        })
    },
    clickColumn(val) {
      if (this.view.hides.includes(val.value)) {
        this.view.hides = this.view.hides.filter(x => x != val.value)
      } else {
        if (
          !val.title &&
          this.view.titleCid !== val.value &&
          (this.view.type === "GANTT" && this.view.ganttConfig.milestone
            ? this.view.ganttConfig.milestone !== val.value
            : true)
        ) {
          this.view.hides.push(val.value)
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.hide-dropdown {
  .selector {
    margin-top: 15px;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    padding: 0 15px;
    line-height: 32px;
    cursor: pointer;
  }
  .selector-diabled {
    background-color: #f5f7fa;
    border-color: #e4e7ed;
    color: #303133;
    cursor: not-allowed;
  }
}
.around-list {
  padding: 6px;
  .quick-operate {
    height: 32px;
  }
  .column-check-list {
    max-height: 362px;
    display: grid;
    margin-top: 5px;
    .control-column {
      height: 36px;
      width: 100%;
      align-items: center;
      display: flex;
      cursor: pointer;
      &:hover {
        background-color: #f5f5f5;
        border-radius: 3px;
        .mover {
          visibility: visible;
        }
      }
    }
  }
  .el-switch {
    padding-right: 5px;
  }
  .quick-button {
    width: 48%;
  }
  .mover {
    margin-left: auto;
    margin-right: 10px;
    font-size: 18px;
    visibility: hidden;
  }
  .el-switch {
    width: 22px;
    padding-right: 10px;
    margin-left: 5px;
    ::v-deep {
      .el-switch__core {
        width: 22px !important;
        height: 11px;
      }
      .el-switch__core::after {
        height: 6px;
        width: 6px;
      }
    }
  }
  ::v-deep {
    .el-switch.is-checked .el-switch__core::after {
      margin-left: -7px;
    }
  }
}
</style>
